// OpModule — Layer 3, operative Module mit konkreten Aktionen.
// Wraps existing card logic, throws nichts weg, nur visuelles Restyling.
//
// Varianten:
//   "heute"    — TodayBriefing + PetraCalls kombiniert
//   "pipeline" — Tooltime-Pipeline + Forderungen
//   "termine"  — Vacations (14 Tage) + Großhändler-Forecast

import { ReactNode } from "react";

interface Props {
  variant: "heute" | "pipeline" | "termine";
  title: string;
  subtitle?: string;
  children: ReactNode;
  badgeCount?: number;
}

const VARIANT_ACCENT: Record<Props["variant"], string> = {
  heute: "border-sky-500/20 bg-gradient-to-br from-sky-500/[0.04] to-slate-950",
  pipeline: "border-violet-500/20 bg-gradient-to-br from-violet-500/[0.04] to-slate-950",
  termine: "border-amber-500/20 bg-gradient-to-br from-amber-500/[0.04] to-slate-950",
};

export default function OpModule({ variant, title, subtitle, children, badgeCount }: Props) {
  return (
    <section className={`rounded-2xl border ${VARIANT_ACCENT[variant]} p-4 sm:p-5`}>
      <header className="mb-4 flex items-baseline justify-between gap-2">
        <div>
          <h3 className="text-sm font-semibold text-slate-100">{title}</h3>
          {subtitle && <p className="text-xs text-slate-400 mt-0.5">{subtitle}</p>}
        </div>
        {badgeCount !== undefined && badgeCount > 0 && (
          <span className="text-xs bg-slate-800 text-slate-200 px-2 py-0.5 rounded-full tabular-nums">
            {badgeCount}
          </span>
        )}
      </header>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
